import React from 'react'
import styled from 'styled-components'
import Modal from 'react-modal'
import moment from 'moment'
import { notify } from 'react-notify-toast'
import { isMobile } from 'react-device-detect'

import { CloseButton } from '../DropdownMenu.jsx'
import { fontSizeResponsive, mediaQ } from '../../../theme/mixins'

export const DropdownModalContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 10px 20px;
`
export const DropdownModalRow = styled.div`
  display: flex;
  flex-direction: row;
`
export const DropdownModalHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  font-family: 'Asap Condensed';
  font-weight: bold;
  font-stretch: condensed;
  font-style: normal;
  line-height: 1.15;
  -webkit-letter-spacing: normal;
  -moz-letter-spacing: normal;
  -ms-letter-spacing: normal;
  letter-spacing: normal;
  color: #fe0d9f;
  padding: 20px 0;

  ${fontSizeResponsive(40)};
`
export const DropdownModalRowText = styled.span`
  font-family: 'Open Sans';
  font-stretch: condensed;
  ${fontSizeResponsive(20)};
  margin: 8px 0;

  ${mediaQ('mobileAll', 'margin: 1px 0;')}

  &:before {
    content: '|';
    ${fontSizeResponsive(24)};
  }

  .date {
    display: block;
    width: 100%;
    margin: 5px 10px;
  }

  span {
    font-weight: bold;
    margin-left: 5px;
    ${fontSizeResponsive(22)};
  }
`

export const DropdownModalSubHeader = styled.div`
  font-family: 'Open Sans', sans-serif;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  -webkit-letter-spacing: normal;
  -moz-letter-spacing: normal;
  -ms-letter-spacing: normal;
  letter-spacing: normal;
  color: #212121;
  ${fontSizeResponsive(24)};
  margin-bottom: 20px;

  span {
    font-weight: bold;
    ${fontSizeResponsive(28)};
    color: rgba(158, 13, 254, 1);
    margin-left: 5px;
  }
`

const DropdownModalSecondHaeder = styled.div`
  width: 50%;
  margin-left: 35%;
  font-family: 'Open Sans', sans-serif;
  font-weight: 700;
  ${fontSizeResponsive(26)};

  ${mediaQ('mobileAll', 'width:100%; margin-left: 0;text-align: center;')}
`
const DiagnosticDataContainer = styled.div`
  margin: 15px 0px;
  background-color: rgba(0, 0, 0, 0.036);
  border: 1px solid rgba(0, 0, 0, 0.036);
  width: 50%;
  align-self: center;
  border-radius: 7px;
  padding: 5px 10px;
  box-shadow: 0 2.5px 1.4px -26px rgba(0, 0, 0, 0.011),
    0 6.1px 3.3px -26px rgba(0, 0, 0, 0.016),
    0 11.4px 6.3px -26px rgba(0, 0, 0, 0.02),
    0 20.3px 11.2px -26px rgba(0, 0, 0, 0.024),
    0 38px 20.9px -26px rgba(0, 0, 0, 0.029),
    0 91px 50px -26px rgba(0, 0, 0, 0.04);

  ${mediaQ('mobileAll', 'width:100%;')}
`

const DropdownModalCopyButton = styled.button`
  width: 45%;
  align-self: center;
  padding: 10px 30px;
  border: none;
  outline: none;
  background: linear-gradient(
    90deg,
    rgba(254, 13, 160, 1) 0%,
    rgba(250, 174, 1, 1) 100%
  );
  font-family: 'Asap Condensed';
  text-align: center;
  font-weight: 600;
  color: white;
  transition: ease-in-out 0.35s all;
  ${fontSizeResponsive(26)};

  ${mediaQ('mobileAll', 'width:80%;')}

  &:hover {
    transform: scale(1.025);
    border: none;
  }
`

const DropdownModal = ({
  modalIsOpen,
  closeModal,
  user,
  userId,
  afterOpenModal,
}) => {
  const customStyles = {
    overlay: { zIndex: 1000, backgroundColor: `rgba(0, 0, 0, 0.5)` },
    content: {
      right: `unset`,
      bottom: `unset`,
      top: `${isMobile ? '5%' : '50%'}`,
      left: `${isMobile ? 'unset' : '50%'}`,
      transform: `${isMobile ? 'translate(0%, 0%);' : 'translate(-50%, -50%)'}`,
    },
  }

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(user.formattedData)
      notify.show('Skopiowano dane do schowka.', 'success', 2000)
    } catch (err) {
      notify.show(
        `Pojawił się problem przy kopiowaniu danych do schowka: ${err}`,
        'error',
        2000
      )
    }
  }

  return (
    <Modal
      isOpen={modalIsOpen}
      onAfterOpen={afterOpenModal}
      onRequestClose={closeModal}
      style={customStyles}
      afterOpenModal={afterOpenModal}
    >
      <DropdownModalContainer className="DropdownModal">
        <CloseButton onClick={closeModal} modal />
        <DropdownModalHeader>Zgłoś błąd</DropdownModalHeader>
        <DropdownModalSubHeader>
          By zgłosić błąd, proszę wyślij email na adres
          <span>miazga@fitmatkawariatka.pl</span> zawierający opis problemu,
          oraz dodaj poniższe dane diagnostyczne, które ułatwią naprawę
          problemu.
        </DropdownModalSubHeader>
        <DropdownModalSecondHaeder>
          Dane diagnostyczne:
        </DropdownModalSecondHaeder>

        <DiagnosticDataContainer>
          <DropdownModalRow>
            <DropdownModalRowText>
              UserId: <span>{user.objectData.id}</span>
            </DropdownModalRowText>
          </DropdownModalRow>

          <DropdownModalRow>
            <DropdownModalRowText>
              Platforma: <span>{user.objectData.platform}</span>
            </DropdownModalRowText>
          </DropdownModalRow>

          <DropdownModalRow>
            <DropdownModalRowText>
              System: <span>{user.objectData.systemFamily}</span>
            </DropdownModalRowText>
          </DropdownModalRow>

          <DropdownModalRow>
            <DropdownModalRowText>
              Wersja systemu: <span>{user.objectData.systemVersion}</span>
            </DropdownModalRowText>
          </DropdownModalRow>

          <DropdownModalRow>
            <DropdownModalRowText>
              Architekrura systemu:{' '}
              <span>{user.objectData.systemArchitecture}</span>
            </DropdownModalRowText>
          </DropdownModalRow>

          <DropdownModalRow>
            <DropdownModalRowText>
              Nazwa przeglądarki: <span>{user.objectData.browserName}</span>
            </DropdownModalRowText>
          </DropdownModalRow>

          <DropdownModalRow>
            <DropdownModalRowText>
              Wersja przeglądarki: <span>{user.objectData.browserVersion}</span>
            </DropdownModalRowText>
          </DropdownModalRow>

          <DropdownModalRow>
            <DropdownModalRowText>
              Rozdzielczość:
              <span>
                {user.objectData.clientWidth} x {user.objectData.clientHeight}
              </span>
            </DropdownModalRowText>
          </DropdownModalRow>

          <DropdownModalRow>
            <DropdownModalRowText>
              Dni treningowe:{' '}
              <span>[{user.objectData.trainingDays.join(', ')}]</span>
            </DropdownModalRowText>
          </DropdownModalRow>

          <DropdownModalRow>
            <DropdownModalRowText>
              Data ostatnio obejrzanego treningu miazga:{' '}
              <span className="date">
                {user.objectData.lastWatchedVid == 'brak'
                  ? user.objectData.lastWatchedVid
                  : moment(user.objectData.lastWatchedVid).format()}
              </span>
            </DropdownModalRowText>
          </DropdownModalRow>

          <DropdownModalRow>
            <DropdownModalRowText>
              Data ostatnio zablokowanego treningu miazga:
              <span className="date">
                {user.objectData.lastWatchedVid == 'brak'
                  ? user.objectData.lastLockedVid
                  : moment(user.objectData.lastLockedVid).format()}
              </span>
            </DropdownModalRowText>
          </DropdownModalRow>
        </DiagnosticDataContainer>

        <DropdownModalCopyButton onClick={copyToClipboard}>
          Skopiuj dane diagnostyczne
        </DropdownModalCopyButton>
      </DropdownModalContainer>
    </Modal>
  )
}
export default DropdownModal
